import { createBrowserRouter, createHashRouter } from 'react-router-dom'
import HomePage from './pages/HomePage'
import G6ThumbCameraPage from './pages/G6ThumbCameraPage'
import RetroMiniCameraPage from './pages/RetroMiniCameraPage'
import MiniDigitalCameraPage from './pages/MiniDigitalCameraPage'
import FAQPage from './pages/FAQPage'
import AboutPage from './pages/AboutPage'
import PrivacyPage from './pages/PrivacyPage'
import TermsPage from './pages/TermsPage'
import Layout from './components/Layout'

export const routes = [
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'g6-thumb-camera', element: <G6ThumbCameraPage /> },
      { path: 'retro-mini-camera', element: <RetroMiniCameraPage /> },
      { path: 'mini-digital-camera', element: <MiniDigitalCameraPage /> },
      { path: 'faq', element: <FAQPage /> },
      { path: 'about', element: <AboutPage /> },
      { path: 'privacy', element: <PrivacyPage /> },
      { path: 'terms', element: <TermsPage /> },
    ]
  }
]

// For static hosting, we use hash router as fallback
// But for SSG prerendering, we use browser router
export const createRouter = () => {
  // Use BrowserRouter for SSG pre-rendering
  return createBrowserRouter(routes)
}

export default createRouter
